<!-- image-display.component.html -->
<div>
    <img *ngIf="imageSrc" [src]="imageSrc" alt="Blob Image" />
    <p *ngIf="!imageSrc">Loading...</p>
  </div>